import React, { useState } from "react";
import ApiKeysLandingPage from "./ApiKeysLandingPage";
import Logger from "../../../libs/Logger";
import ApiKeyModals from "./Modals/ApiKeyModals";

const ApiKeys = () => {
  const log = new Logger({ module: "Settings", component: "ApiKeys" });
  return (
    <div className="w-full flex flex-col lg:space-y-6">
      <ApiKeysLandingPage />
      <ApiKeyModals />
    </div>
  );
};

export default ApiKeys;
